export type IfBulkUpdateTicketsResponse = {
  /**
   * The results of this if_bulk_update_tickets response body.
   */
  result: Result[];
};

export type Result = {
  index: number;
  ifReqId: string;
  messageList: Message[];
  errorColumnList: string[];
};

export type Message = {
  val: string;
  col: string[];
};
